// extracted by mini-css-extract-plugin
export var avatarContainer = "_m-0";
export var avatarTypingWave = "_m-i";
export var gray = "_m-f";
export var green = "_m-c";
export var icon = "_m-9";
export var image = "_m-1";
export var lg = "_m-6";
export var md = "_m-5";
export var presenceDot = "_m-b";
export var red = "_m-d";
export var sm = "_m-4";
export var status = "_m-a";
export var typingDot = "_m-h";
export var typingPill = "_m-g";
export var xl = "_m-7";
export var xs = "_m-3";
export var xxl = "_m-8";
export var xxs = "_m-2";
export var yellow = "_m-e";